
import Vue from "vue";
import {Component} from "vue-property-decorator";
import ClickOutside from "../VueIntegration/ClickOutside";

@Component({directives: {
        "click-outside": ClickOutside
    }})
export default class ContextMenu extends Vue {
    private initialFocus = document.activeElement;

    mounted() {
        this.initialFocus = document.activeElement;
        setTimeout(() => {
            this.canExit = true;
            (<HTMLElement> this.$el).focus();
            document.addEventListener('focusin', this.onFocusInEventHandler);
        }, 100);
    }

    onFocusInEventHandler = this.onFocusIn.bind(this);

    onFocusIn(e: FocusEvent) {
        e = e || <FocusEvent> window.event;
        let modalContent = <HTMLElement> this.$el;
        if (!modalContent.contains(e.target as Node)) {
            modalContent.focus();
        }
    }

    canExit = false;
    preserveFocus = true;

    exit(event: Event, preserveFocus: boolean) {
        if (!this.canExit)
            return;

        this.preserveFocus = preserveFocus;
        this.$emit('close');
    }

    i = -1;

    down() {
        this.i += 1;
        let children = this.$el.children;
        this.i = this.i % children.length;
        let child = <HTMLElement> children[this.i];
        child.focus();
    }

    up() {
        this.i -= 1;
        let children = this.$el.children;
        if (this.i < 0)
            this.i = children.length - 1;

        let child = <HTMLElement> children[this.i];
        child.focus();
    }

    beforeDestroy() {
        if (this.initialFocus !== null && (this.initialFocus instanceof HTMLElement)) {
            this.initialFocus.focus();
        }

        document.removeEventListener('focusin', this.onFocusInEventHandler)
    }
}
